import FormattedMessage from 'I18n/components/FormattedMessage';
import { HubMerchCardLayoutUI } from '../../containers/merch-card/HubMerchCardLayoutUI';
import { StarterLowerTierMessage } from '../../containers/merch-card/StarterLowerTierMessage';
import { useIsFreePortal } from '../../hooks/inventory/useProductInventory';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataHubMerchCards = () => {
  const {
    isFreePortal,
    loading
  } = useIsFreePortal();
  const productsConfig = {
    STARTER: {
      apiName: 'operations-hub-starter',
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.data.starterCard.description"
      }),
      lowerTierMessage: StarterLowerTierMessage({
        isFreePortal,
        loading
      })
    },
    PROFESSIONAL: {
      apiName: 'operations-hub-professional',
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.data.professionalCard.description"
      }),
      lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.data.professional.lowerTierPlus"
      })
    },
    ENTERPRISE: {
      apiName: 'operations-hub-enterprise',
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.data.enterpriseCard.description"
      }),
      lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.data.enterprise.lowerTierPlus"
      })
    }
  };
  return /*#__PURE__*/_jsx(HubMerchCardLayoutUI, {
    productsConfig: productsConfig
  });
};